import { Component } from '@angular/core';
import { GeneralService } from '../../services/general.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  logoUrl = '';

  constructor(public gs: GeneralService) {
    //this.logoUrl = this.gs.buildImagemUrl('logo-footer.png');
  }

}
